export default __webpack_public_path__ + "static/media/BSC.6950ba42.png";